import React from 'react';
import { KompisOpenDesignCode } from '@inter-ikea-kompis/react-components';
import OpenDesignStateEnum from '@inter-ikea-kompis/component-open-design-code/lib/enums/OpenDesignCodeStateEnum';
import Box from 'ui/Box';
import styled from 'styled-components';
import { SpaceProps } from 'styled-system';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useServiceSettings } from 'contexts/serviceSettings';

const Wrapper = styled(Box)`
  display: flex;
`;

export enum VPCLoadingState {
  default = 'default',
  loading = 'loading',
  failed = 'failed'
}

type Props = SpaceProps & {
  onOpen: (e?: any) => void;
  state: OpenDesignStateEnum;
};

function LoadVpc({ onOpen, state, ...props }: Props) {
  const { translations } = useServiceSettings();

  return (
    <Wrapper {...props}>
      <KompisOpenDesignCode
        state={state}
        onOpen={onOpen}
        translations={translations.kompis}
        theme={SkapaTheme}
      />
    </Wrapper>
  );
}

export default LoadVpc;
